import axios from 'axios'
import qs from 'qs'
import router from '../router'
import store from '../store'


axios.defaults.baseURL = common.host + '/admin'; //  请求服务器具体的地址
axios.defaults.imgURL = common.host; //  请求服务器具体的地址

// 请求拦截器
axios.interceptors.request.use(config => {
    const token = localStorage.getItem('X-Token')
    if (token) {
        config.headers['X-Token'] = token
    }
    config.headers['X-Lang'] = store.state.i18n;

    config.data = qs.stringify(config.data);
    return config
}, error => {
    return Promise.reject(error)
})


// 响应拦截器
axios.interceptors.response.use(res => {
    //登录状态失效
    if (res.data.message == '賬號異地登入' || res.data.message == '登入超時' || res.data.message == '用戶未登入') {
        router.push({
            name: 'Login',
        });
        localStorage.removeItem('X-Token')
    }
    return res
}, error => {
    return Promise.reject(error)
})




export default axios


// WEBPACK FOOTER //
// ./src/axios/index.js